<template>
  <div class="main-wrapper">
    <navbareight></navbareight>

      <indexeighthome />

      <indexeightvaciences />
      
      <indexeightjob />

      <indexeightpartners />

      <indexeightad />

      <indexeighttestimonial />

      <indexeightblog />

      <indexeightadbanner />

      <indexeightfooter />

      <scroll />

  </div>
</template>
